import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgOneCommentIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={3.5}
      d="M58 8H6a2 2 0 0 0-2 2v28.762a2 2 0 0 0 2 2h10.378a2 2 0 0 1 2 2V54a2 2 0 0 0 2 2h3.846a2 2 0 0 0 1.566-.756l10.907-13.726a2 2 0 0 1 1.566-.756H58a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Z"
    />
  </svg>
)
export default SvgOneCommentIcon
